import './PercentageInput.scss';

import cx from 'classnames';
import type { ChangeEvent } from 'react';
import React, { memo } from 'react';

import bem from '../../utils/bem';

type Props = {
  value: number | null;
  onChange: (newValue: number | null) => void;
  className?: string;
  emptyValue?: number;
  icon?: React.JSX.Element;
  error?: boolean;
  disabled?: boolean;
  maxValue?: number;
};

const DEFAULT_VALUE = 0;

const [block, element] = bem('percentage-input');

const PercentageInput = ({
  value,
  onChange,
  emptyValue,
  className,
  icon,
  error,
  disabled,
  maxValue,
}: Props): JSX.Element => {
  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>): void => {
    e.preventDefault();

    let numberValue = e.target?.value ? parseInt(e.target?.value) : emptyValue ?? DEFAULT_VALUE;

    if (Number.isNaN(numberValue)) {
      onChange(null);
    } else {
      onChange(maxValue ? Math.min(numberValue, maxValue) : numberValue);
    }
  };

  return (
    <div className={cx(block(error ? 'error' : null), className)}>
      <input
        value={value ?? DEFAULT_VALUE}
        onChange={onChangeHandler}
        className={element('input')}
        type="number"
        disabled={disabled}
      />
      {icon && <span className={element('icon', disabled ? 'disabled' : null)}>{icon}</span>}
    </div>
  );
};

export default memo(PercentageInput);
